export enum EmploymentResponsiblePosition {
None,
Executive,
SalarySixTimesTheBasic,
SalaryEightTimesTheBasic,
}
